import React from "react";

/**
 * Minimal page-level error boundary. Keeps a bad render from blanking the app.
 * Shows a short red card so the CEO can still navigate away.
 */
export class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // Log to the console so the browser devtools still show the real stack.
    // eslint-disable-next-line no-console
    console.error("[PageErrorBoundary]", error, info?.componentStack);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div className="p-6 sm:p-10" data-testid="page-error-boundary">
          <div className="max-w-xl border border-rose-500/40 bg-rose-500/5 rounded-xl p-5">
            <h2 className="font-display text-lg text-rose-500 mb-1">Something broke on this page</h2>
            <p className="text-sm text-muted-foreground">
              The rest of the Office still works. Try reloading, or go back to another page.
            </p>
            <pre className="mt-3 font-mono text-[11px] text-rose-400 whitespace-pre-wrap break-words">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              onClick={this.reset}
              className="mt-3 font-mono text-[11px] uppercase tracking-wider text-[color:var(--cobalt)] hover:underline"
              data-testid="page-error-retry"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
